module.exports = __webpack_public_path__ + "img/tel.8095175f.png";